import { render, staticRenderFns } from "./MentionItem.vue?vue&type=template&id=ca08dde2&scoped=true"
import script from "./MentionItem.vue?vue&type=script&lang=ts"
export * from "./MentionItem.vue?vue&type=script&lang=ts"
import style0 from "./MentionItem.vue?vue&type=style&index=0&id=ca08dde2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca08dde2",
  null
  
)

export default component.exports